import companiesData from '@/data/companies-data.json'
import projectsData from '@/data/projects-data.json'
import africaGeojson from '@/data/africa-geojson.json'
const { companies } = companiesData
const { projects, budgetsPerCountry } = projectsData

const getCompanies = () => {
  return companies.map(c => Object.freeze(c))
}
const getProjects = () => {
  return projects.map(p => Object.freeze(p))
}
const getProjectBudgetsPerCountry = () => {
  return budgetsPerCountry
}
const getAfricaGeojson = () => {
  return africaGeojson
}

export default {
  getCompanies,
  getProjects,
  getProjectBudgetsPerCountry,
  getAfricaGeojson,
}
